const getInputBorderStyle = palette => ({
  border: `1px solid ${palette.neutralSecondary}`,
  '&:focus': {
    border: `1px solid ${palette.themePrimary}`,
  },
});

export const adgroupsKeywordsStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .mixed-mode-adgroup-create .dynamic-ad-group-create-view-container .landing-page-container': {
    marginBottom: 0,
  },

  '& .mixed-mode-adgroup-create .HelpTopic': {
    marginLeft: 5,
  },

  '& .mixed-mode-adgroup-create .authoring-container label': {
    paddingLeft: 28,
  },

  '& .adgroups-keywords__container, .keyword-section': {

    '& .panel': {
      border: 0,
      boxShadow: 'none',
    },

    '& .landing-page-container': {
      width: 447,
      padding: 0,
      marginBottom: 36,

      '&  .pull-left': {
        float: 'none',
        display: 'inline-block',
      },

      '&  .pull-left:nth-child(2)': {
        position: 'absolute',
        top: 68,
        left: -8,
        padding: [8, 5, 8, 8],

        '&:focus-within': {
          outline: '1px solid #605E5C',
        },

        '& input[type="checkbox"]': {
          outline: 'none',
        },
      },

      '& .landing-page-container__label': {
        fontSize: 14,
      },

      '& .landing-page-container__checkbox': {
        margin: '0 8px 0 0 !important',
        verticalAlign: 'middle',
        position: 'relative',
      },

      '&  div:nth-child(2)': {
        marginTop: 8,
      },

      '& .form-control': {
        width: '100%',
        ...getInputBorderStyle(palette),
      },
    },

    '& .ad-group-list-container': {
      width: 460,
      padding: '8px 0 0 0',
      marginTop: 18,
      marginBottom: 80,
    },

    '& .ad-group-list': {
      width: 447,
      borderTop: `1px solid ${palette.neutralSecondary}`,
      padding: 0,
    },

    '& .ad-group-list-container .form-control, .adgroup__body .form-group': {
      width: 416,

      '& input.adgroup-name, textarea.keyword-textarea': {
        ...getInputBorderStyle(palette),
      },
    },

    '& .adgroup__body': {
      padding: 0,
      width: 416,
      marginLeft: 30,

      '& .form-group > #KoErrors': {
        marginLeft: 0,
      },
    },

    '& .ad-group-collapsible, .parser': {
      position: 'relative',

      '& textarea.error': {
        color: palette.neutralSecondary,
      },
    },

    '& .ad-group-list > .row': {
      position: 'relative',
      paddingBotton: 15,

      '& div[data-bind="visible: !isDeleted()"]': {
        borderBottom: `1px solid ${palette.neutralSecondary}`,
      },
    },

    '& .ad-group-list__col-sm-1--remove': {
      position: 'absolute',
      top: 8,
      right: 0,
      zIndex: 1,
      width: 'auto',
      height: '32px',
      padding: 0,
    },

    '& .ad-group-list__col-sm-1--remove .glyphicon-remove': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      color: palette.black,
      minWidth: 106,
      height: '32px',
      border: '1px solid #8A8886',
      borderRadius: 2,
      padding: '2px 12px',

      '&:hover': {
        textDecoration: 'none',
        backgroundColor: palette.neutralLighter,
      },

      '&:focus': {
        outline: `1px solid ${palette.neutralSecondaryAlt}`,
        boxShadow: `inset 0 0 0 1px ${palette.neutralSecondary}`,
        outlineOffset: 0,
        border: `2px solid ${palette.white}`,
      },

      '& span': {
        fontFamily: 'Segoe UI,Tahoma,Geneva,Verdana,sans-serif',
        fontSize: 14,
        fontWeight: 600,
        color: palette.neutralPrimary,
        lineHeight: '19px',
      },
    },

    '& .ad-group-list__col-sm-1--remove .glyphicon-remove:before': {
      content: '"\\E738"',
      position: 'relative',
      top: 5,
      paddingRight: 8,
    },

    '& .ad-group-list__col-sm-1--toggle': {
      marginTop: 6,
      padding: 0,
      width: 30,
    },

    '& .ad-group-list-container.ad-group--no-toggle': {
      '& .ad-group-list__col-sm-1--toggle': {
        display: 'none',
      },

      '& .adgroup__body': {
        marginLeft: '0 !important',
        width: 447,

        '& .form-group, .form-control': {
          width: 447,
        },

        '& input.adgroup-name, textarea.keyword-textarea': {
          ...getInputBorderStyle(palette),
        },

        '& #Keyword_Bmm_Warning_Div': {
          padding: '8px 32px 8px 8px',
          marginBottom: 8,
        },

        '& #Keyword_Bmm_Block_Div': {
          padding: '8px 32px 8px 8px',
          marginBottom: 8,
        },
      },

      '& .ad-group-list__col-sm-1__label': {
        color: '#323130',
      },
    },

    '& .ad-group-list__glyphicon': {
      fontFamily: iconFontFamily,
      fontSize: 18,
      color: palette.themePrimary,
    },

    '& .ad-group-list__col-sm-1--toggle .ad-group-list__glyphicon': {
      width: 30,
    },

    '& .glyphicon-chevron-down:before': {
      content: '"\\E76C"',
    },

    '& .glyphicon-chevron-up:before': {
      content: '"\\E70D"',
    },

    '& .ad-group-list__col-sm-1__label': {
      fontSize: 14,
      color: palette.themePrimary,
    },

    '& .accordion-toggle.clickable': {
      '&:focus, &:hover': {
        backgroundColor: palette.neutralLighter,
      },

      '& .ad-group-list__col-sm-1__label': {
        fontSize: 18,
      },
    },

    '& .accordion-with-popup-help': {
      display: 'flex',
      alignItems: 'center',

      '& .helpbutton': {
        marginTop: 15,
      },
    },

    '& .accordion-toggle': {
      marginTop: 8,
      outline: 'none',
      display: 'flex',
    },

    '& .accordion-toggle[aria-expanded="false"] + .row': {
      '& .adgroup__body': {
        '& input.adgroup-name': {
          border: 0,
          marginBottom: 8,
          cursor: 'default',
        },

        '& .remaining-hint': {
          display: 'none',
        },
      },
    },

    '& .accordion-toggle .col-sm-10': {
      padding: 0,
    },

    '& .btn-create-adgroup': {
      marginTop: 36,

      '&:focus': {
        left: 1,
      },
    },

    '& .ad-group-list__col-sm-1--toggle+.col-sm-9': {
      width: 447,
      padding: 0,
    },

    '& .deletedConfirmation': {
      marginBottom: 20,
      marginTop: 20,
      overflowWrap: 'anywhere',
    },

    '& .keyword-planner-root .keyword-planner-container .glyphicon.form-control-feedback': {
      fontFamily: iconFontFamily,
      width: 12,
      height: 38,
    },
  },

});

